import { getCommonNotificationsListQueryKey } from "../services/common/generated/common-notifications/common-notifications";
import {
  getConversationsDetailRetrieveQueryKey,
  getConversationsListQueryKey,
  getConversationsMessagesListQueryKey,
} from "../services/messages/generated/conversations/conversations";

/**
 * The backend has no websocket or push channel, so the Messages page polls:
 * the open thread often, the conversation list (unread counts, new
 * conversations) less often. Polling stops while the tab is hidden
 * (TanStack Query's default `refetchIntervalInBackground: false`).
 */
export const THREAD_POLL_MS = 5_000;
export const CONVERSATION_LIST_POLL_MS = 15_000;

/** Queries to refresh after sending in, or marking read, conversation `apiId`. */
export function conversationQueryKeysToRefresh(apiId: string): ReadonlyArray<readonly unknown[]> {
  return [
    getConversationsListQueryKey(),
    getConversationsMessagesListQueryKey(apiId),
    getConversationsDetailRetrieveQueryKey(apiId),
    // The bell's unread count includes "New message" notifications.
    getCommonNotificationsListQueryKey(),
  ];
}
